Promise.all([import('@meteora-digital/accordion-grids'), import('scripts/marmalade/accessibility/navigation')]).then(_ref => {
  let [moduleAccordionGrid, moduleAccessibleNavigation] = _ref;
  const AccordionGridController = moduleAccordionGrid.default;
  const {
    trapFocus
  } = moduleAccessibleNavigation;
  DomObserver.observe('.js-default-team', blocks => {
    blocks.forEach(block => {
      // Store all the dropdowns here
      const dropdowns = [];
      // Find all the items in the block
      const items = [...block.querySelectorAll('.js-default-team__item')];

      // Look for the form to filter the items
      const form = block.querySelector('.js-default-team__form');

      // Loop all the items
      items.forEach(item => {
        // Get the

        // Grab the content from the item
        const content = item.querySelector('.js-default-team__content');
        // Find the button
        const button = item.querySelector('.js-default-team__button');
        // Find the close button
        const close = item.querySelector('.js-default-team__close');

        // If there is no content
        if (!content) return;

        // Create a new dropdown
        const Dropdown = new AccordionGridController(item);

        // Add the item's content to the dropdown
        Dropdown.setContent(content);
        trapFocus(content.querySelectorAll('a, button'));

        // Add the dropdown to the dropdowns array
        dropdowns.push(Dropdown);
        Dropdown.on('close', () => {
          item.classList.remove('active');
          button.setAttribute('aria-expanded', 'false');
          button.focus();
        });
        Dropdown.on('open', () => {
          item.classList.add('active');
          dropdowns.forEach(d => {
            if (d !== Dropdown) d.close();
          });
          button.setAttribute('aria-expanded', 'true');
        });
        button.addEventListener('click', () => {
          Dropdown.toggle();
          content.focus();
        });

        // If the user presses right arrow, open the dropdown
        button.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight') {
            Dropdown.open();
            // Focus the content
            content.focus();
          }
        });
        close.addEventListener('click', () => {
          // Return the focus to the button
          button.focus();
          // Close the dropdown
          Dropdown.close();
        });
        content.addEventListener('keydown', event => {
          if (event.key === 'ArrowLeft') {
            // Close the dropdown
            Dropdown.close();
            // Focus the button
            button.focus();
          }
          if (event.key === 'Tab' || event.keyCode === 9) {
            if (event.shiftKey) {
              if (document.activeElement === content) {
                event.preventDefault();
                Dropdown.close();
              }
            }
          }
        });
      });
      if (form) {
        // Set up an array to hold the form keys
        const formKeys = [];
        // Set up a map to store the data for each item
        const itemData = new Map();

        // Get the form data, and extract the keys
        new FormData(form).entries().forEach(_ref2 => {
          let [key, value] = _ref2;
          formKeys.push(key);
        });
        const filterItems = () => {
          // Get the form data
          const formData = new FormData(form);

          // Check if all form keys have empty values
          const allKeysEmpty = formKeys.every(key => formData.getAll(key).length === 0);
          if (allKeysEmpty) {
            // Show all items
            items.forEach(item => item.classList.remove('hidden'));
            return;
          }

          // Close all the dropdowns
          dropdowns.forEach(d => d.close());
          let hiddenCount = 0;

          // Loop all the items and check if any of the data from the form is included in the item's data
          items.forEach(item => {
            const data = itemData.get(item);
            let show = true;
            formKeys.forEach(key => {
              const value = formData.get(key);
              if (!value) return;
              if (data[key].length === 0) {
                show = false;
                return;
              }
              if (!data[key].includes(value)) {
                show = false;
              }
            });
            if (show) {
              item.classList.remove('hidden');
            } else {
              item.classList.add('hidden');
              hiddenCount += 1;
            }
          });
          console.log(hiddenCount, items.length);
          block.classList.toggle('no-results', hiddenCount === items.length);
        };

        // Loop all the items and grab their data from the corresponding attributes on the item
        items.forEach(item => {
          const data = {};
          formKeys.forEach(key => {
            let value = item.getAttribute(`data-${key}`);

            // If there is no value, set it to an empty array
            if (!value) return data[key] = [];

            // Try split the value by ,
            if (value && value.includes(',')) {
              value = value.split(',');
            } else {
              value = [value];
            }
            data[key] = value;
          });
          itemData.set(item, data);
        });

        // When the form changes
        form.addEventListener('change', () => filterItems());
        // Prevent the form from submitting
        form.addEventListener('submit', e => e.preventDefault());

        // Filter the items on load
        filterItems();
      }
    });
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});